var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SkillsMultiselect", {
    attrs: {
      title: "Skills",
      value: _vm.skillsIdsFromDB,
      newSkills: _vm.newSkillsNames,
      getParentStyle: _vm.getParentContainer,
      disabled: _vm.disabled,
      max: _vm.max,
      placeholder: _vm.customSkillLabel,
      companyId: _vm.companyId,
      withCustomSkills: "",
    },
    on: { input: _vm.updateSkillList, search: _vm.search },
    scopedSlots: _vm._u(
      [
        {
          key: "noResult",
          fn: function ({ currentSearchString }) {
            return [
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(currentSearchString)),
              ]),
              _vm._v(" - is already selected "),
            ]
          },
        },
        {
          key: "option",
          fn: function ({ option: skill, newSkill }) {
            return [
              newSkill
                ? _c("SkillMultiselectItem", {
                    attrs: {
                      labelText: _vm.newSkillLabel,
                      skillName: skill.name,
                    },
                  })
                : _vm._e(),
              _vm._t("default", null, { skill: skill }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }